/**
 * Banner shown in the approval modal when the line being approved is only
 * part of a receipt that was shared across several client matters. Purely
 * presentational — the caller resolves the translated label and notice text
 * (via the modal's own `translate(data, key, fallback)` helper, which
 * already falls back safely on a missing locale key) so this component
 * never touches `data.t.read` directly.
 *
 * @param {object} props
 * @param {string} props.label - The already-translated banner label (e.g. "Shared receipt").
 * @param {string} props.notice - The already-translated, already-interpolated notice sentence.
 * @returns {JSX.Element} The notice banner.
 */
export default function SharedReceiptNotice({label, notice}) {
    return (
        <div className="alert alert-light border mb-3">
            <strong>{label}</strong> — {notice}
        </div>
    );
}
